import React, { memo } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ErrorBoundary } from 'shared/components';

import { OfferError } from './components';
import {
    ConfirmationPage,
    OfferLoader,
    OfferNotFound,
    OfferPagesRenderer,
    ResetStateOnLeave
} from './containers';

function CandidateOfferRoutes() {
    return (
        <Routes>
            <Route element={ <ResetStateOnLeave /> }>
                <Route element={ <OfferLoader /> }>
                    <Route element={ <OfferPagesRenderer /> }>
                        <Route index
                            element={ (
                                <ErrorBoundary>
                                    <ConfirmationPage />
                                </ErrorBoundary>
                            ) }
                        />
                    </Route>
                </Route>
                <Route path="/error"
                    element={ <OfferError /> }
                />
                <Route path="/not_found"
                    element={ <OfferNotFound /> }
                />
            </Route>
        </Routes>
    );
}

CandidateOfferRoutes.displayName = 'CandidateOfferRoutes';

export default memo(CandidateOfferRoutes);
